
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/points-expiration",
      function () {
        return require("private-next-pages/loyalty/points-expiration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/points-expiration"])
      });
    }
  